import { Spinner, Text, Tooltip } from "@vesatogo/grass-core"
import classNames from "classnames"

export type TableSummaryProps = {
  summary: {
    id: string
    title: string
    titleClassName?: string
    value: number | string
    helper?: string
    intentClass?: string
    bgClass?: string
    iconBgClass?: string
    icon?: any
    borderClassName?: any
    valueClassName?: string
    tooltip?: React.ReactNode
  }[]
  loading?: boolean
}
export const TableSummary = ({
  summary,
  loading = false,
}: TableSummaryProps) => {
  return (
    <>
      {summary.map(card => {
        const Icon = card.icon
        const cardContent = (
          <div
            className={classNames(
              card.bgClass,
              "flex justify-between border rounded-xl px-4 py-3 border-gray-300 cursor-pointer",
              card.borderClassName
            )}
          >
            <div className="flex flex-col">
              <Text
                className={classNames(
                  "text-xs text-gray-500",
                  card.titleClassName
                )}
              >
                {card.title}
                <span className="text-xs text-red-500" hidden={!card.helper}>
                  {" "}
                  ({card.helper})
                </span>
              </Text>
              <div className="flex items-end justify-between mt-1">
                <Text
                  className={classNames(
                    "text- font-bold leading-none text-gray-800 font-700",
                    // card.intentClass,
                    card.valueClassName
                  )}
                >
                  {loading ? <Spinner /> : card.value}
                </Text>
              </div>
            </div>
            <div
              className={classNames(
                card.iconBgClass,
                "p-2 h-fit",
                "rounded-lg"
              )}
            >
              {card.icon && <Icon size={25} className={card.intentClass} />}
            </div>
          </div>
        )
        return card.tooltip ? (
          <Tooltip interactive key={card.id} content={card.tooltip}>
            {cardContent}
          </Tooltip>
        ) : (
          <div key={card.id}>{cardContent}</div>
        )
      })}
    </>
  )
}
